module.exports = __webpack_public_path__ + "img/gulp.fcda5c4a.svg";